import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:\\phpstudy_pro\\WWW\\H5\\SSECRM-H5-develop-N\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import _defineProperty from "C:\\phpstudy_pro\\WWW\\H5\\SSECRM-H5-develop-N\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import OrderGoods from "@components/OrderGoods";
import { orderDetail, orderAgain } from "@api/order";
import ClipboardJS from "clipboard";
import Payment from "@components/Payment";
import { isWeixin } from "@utils";
import { mapGetters } from "vuex";
import { cancelOrderHandle, takeOrderHandle, delOrderHandle, payOrderHandle } from "@libs/order";
import { wechatEvevt } from "@libs/wechat";
import GeneralWindow from "@components/GeneralWindow";
var NAME = "OrderDetails";
export default {
  name: NAME,
  components: {
    OrderGoods: OrderGoods,
    Payment: Payment,
    GeneralWindow: GeneralWindow
  },
  props: {},
  data: function data() {
    return {
      offlinePayStatus: 2,
      orderTypeName: "普通订单",
      orderTypeNameStatus: true,
      offlineStatus: true,
      id: this.$route.params.id,
      orderInfo: {
        _status: {}
      },
      status: {},
      pay: false,
      payType: ["yue", "weixin"],
      from: isWeixin() ? "weixin" : "weixinh5",
      system_store: {},
      mapKay: "",
      mapShow: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      }
    };
  },
  computed: _objectSpread({
    refundOrder: function refundOrder() {
      return this.orderInfo.refund_status > 0;
    }
  }, mapGetters(["userInfo"])),
  watch: {
    $route: function $route(n) {
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.getDetail();
      }
    }
  },
  inject: ["app"],
  mounted: function mounted() {
    this.getDetail();
    this.$nextTick(function () {
      var _this = this;

      var copybtn = document.getElementsByClassName("copy-data");
      var clipboard = new ClipboardJS(copybtn);
      clipboard.on("success", function () {
        _this.$dialog.success("复制成功");
      });
    });
  },
  methods: {
    // 再次购买
    goOrderConfirm: function goOrderConfirm(e) {
      var _this2 = this;

      orderAgain(e.order_id).then(function (res) {
        _this2.$router.push({
          path: "/order/submit/" + res.data.cateId
        });
      }).catch(function (res) {
        _this2.$dialog.error(res.msg);
      });
    },
    closeGeneralWindow: function closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.getDetail();
    },
    showChang: function showChang() {
      if (isWeixin()) {
        var config = {
          latitude: parseFloat(this.system_store.latitude),
          longitude: parseFloat(this.system_store.longitude),
          name: this.system_store.name,
          address: this.system_store._detailed_address
        };
        wechatEvevt("openLocation", config).then(function (res) {
          console.log(res);
        }).catch(function (res) {
          if (res.is_ready) {
            res.wx.openLocation(config);
          }
        });
      } else {
        if (!this.mapKey) return this.$dialog.error("暂无法使用查看地图，请配置您的腾讯地图key");
        this.mapShow = true;
      }
    },
    goBack: function goBack() {
      var history = this.app.history,
          last = history[history.length - 1] || {};
      if (last.name === "MyOrder") return this.$router.go(-1);else return this.$router.replace({
        path: "/order/list/"
      });
    },
    cancelOrder: function cancelOrder() {
      var _this3 = this;

      cancelOrderHandle(this.orderInfo.order_id).then(function () {
        setTimeout(function () {
          return _this3.goBack();
        }, 300);
      }).catch(function () {
        _this3.getDetail();
      });
    },
    takeOrder: function takeOrder() {
      var _this4 = this;

      this.$dialog.loading.open("正在加载中");
      takeOrderHandle(this.orderInfo.order_id).then(function (res) {
        if (res.data.gain_integral != "0.00" && res.data.gain_coupon != "0.00" || res.data.gain_integral > 0 && res.data.gain_coupon > 0) {
          _this4.$dialog.loading.close();

          _this4.generalActive = true;
          _this4.generalContent = {
            promoterNum: "\u606D\u559C\u60A8\u83B7\u5F97".concat(res.data.gain_coupon, "\u5143\u4F18\u60E0\u5238\u4EE5\u53CA").concat(res.data.gain_integral, "\u79EF\u5206\uFF0C\u8D2D\u4E70\u5546\u54C1\u65F6\u53EF\u62B5\u73B0\u54E6\uFF5E"),
            title: "恭喜您获得优惠礼包"
          };
          return;
        } else if (res.data.gain_integral != "0.00" || res.data.gain_integral > 0) {
          _this4.$dialog.loading.close();

          _this4.generalActive = true;
          _this4.generalContent = {
            promoterNum: "\u606D\u559C\u60A8\u83B7\u5F97".concat(res.data.gain_integral, "\u79EF\u5206\uFF0C\u8D2D\u4E70\u5546\u54C1\u65F6\u53EF\u62B5\u73B0\u54E6\uFF5E"),
            title: "赠送积分"
          };
          return;
        } else if (res.data.gain_coupon != "0.00" || res.data.gain_coupon > 0) {
          _this4.$dialog.loading.close();

          _this4.generalActive = true;
          _this4.generalContent = {
            promoterNum: "\u606D\u559C\u60A8\u83B7\u5F97".concat(res.data.gain_coupon, "\u5143\u4F18\u60E0\u5238\uFF0C\u8D2D\u4E70\u5546\u54C1\u65F6\u53EF\u62B5\u73B0\u54E6\uFF5E"),
            title: "恭喜您获得优惠券"
          };
          return;
        } else {
          _this4.$dialog.loading.close();

          _this4.$dialog.success("收货成功");
        }

        _this4.getDetail();
      }).catch(function (res) {
        _this4.$dialog.loading.close();

        _this4.$dialog.error(res.msg);
      });
    },
    delOrder: function delOrder() {
      var _this5 = this;

      delOrderHandle(this.orderInfo.order_id).then(function () {
        setTimeout(function () {
          return _this5.goBack();
        }, 300);
      });
    },
    setOfflinePayStatus: function setOfflinePayStatus(status) {
      var that = this;
      that.offlinePayStatus = status;

      if (status === 1 && that.orderTypeNameStatus === true) {
        that.payType.push("offline");
      }
    },
    getOrderStatus: function getOrderStatus() {
      var orderInfo = this.orderInfo || {},
          _status = orderInfo._status || {
        _type: 0
      },
          status = {};

      var type = parseInt(_status._type),
          delivery_type = orderInfo.delivery_type,
          seckill_id = orderInfo.seckill_id ? parseInt(orderInfo.seckill_id) : 0,
          bargain_id = orderInfo.bargain_id ? parseInt(orderInfo.bargain_id) : 0,
          combination_id = orderInfo.combination_id ? parseInt(orderInfo.combination_id) : 0;
      status = {
        type: type,
        class_status: 0
      };

      if (type === 1 && combination_id > 0) {
        status.type = 6;
        status.class_status = 1;
      } //查看拼团


      if (type === 2 && delivery_type === "express") status.class_status = 2; //查看物流

      if (type === 2) status.class_status = 3; //确认收货

      if (type === 4 || type === 0) status.class_status = 4; //删除订单

      if (!seckill_id && !bargain_id && !combination_id && (type === 3 || type === 4)) status.class_status = 5; //再次购买

      if (type == 9) {
        //线下付款
        status.class_status = 0;
        this.offlineStatus = false;
      }

      this.status = status;
    },
    getDetail: function getDetail() {
      var _this6 = this;

      var id = this.id;
      if (!id) return this.$dialog.error("订单不存在");
      orderDetail(id).then(function (res) {
        _this6.orderInfo = res.data;

        _this6.getOrderStatus();

        if (_this6.orderInfo.combination_id > 0) {
          _this6.orderTypeName = "拼团订单";
          _this6.orderTypeNameStatus = false;
        } else if (_this6.orderInfo.bargain_id > 0) {
          _this6.orderTypeName = "砍价订单";
          _this6.orderTypeNameStatus = false;
        } else if (_this6.orderInfo.seckill_id > 0) {
          _this6.orderTypeName = "秒杀订单";
          _this6.orderTypeNameStatus = false;
        }

        _this6.system_store = res.data.system_store || {};
        _this6.mapKey = res.data.mapKey;

        _this6.setOfflinePayStatus(_this6.orderInfo.offlinePayStatus);

        _this6.$nextTick(function () {
          var _this7 = this;

          var copybtn = document.getElementsByClassName("copy-data");
          var clipboard = new ClipboardJS(copybtn);
          clipboard.on("success", function () {
            _this7.$dialog.success("复制成功");
          });
        });
      }).catch(function (err) {
        _this6.$dialog.error(err.msg);

        _this6.$router.go(-1);
      });
    },
    toPay: function () {
      var _toPay = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(type) {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = this;
                _context.next = 3;
                return payOrderHandle(this.orderInfo.order_id, type, that.from).then(function () {}).catch(function (res) {
                  if (res.status === "WECHAT_H5_PAY") that.$router.push({
                    path: "/order/status/" + that.orderInfo.order_id + "/0"
                  });
                });

              case 3:
                that.getDetail();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function toPay(_x) {
        return _toPay.apply(this, arguments);
      }

      return toPay;
    }()
  }
};